// NewChat.js

import React, { Component } from "react";
import CESSVG from "../../../Assets/svg/CESSVG.svg";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import { resetContinueChatSessionAction } from "../../../Actions/AI";
import { GetUserAction } from "../../../Actions/Authentication";

class NewChat extends Component {
  static propTypes = {
    resetContinueChatSessionAction: PropTypes.func.isRequired,
    GetUserAction: PropTypes.func.isRequired,
    user: PropTypes.object,
  };

  componentDidMount() {
    this.props.resetContinueChatSessionAction();
    this.props.GetUserAction();
  }

  render() {
    return (
      <div className="flex flex-col items-center justify-center gap-6 w-full max-w-xl px-4 text-center">
        <img src={CESSVG} alt="CES logo" className="h-10 w-auto" />
        <div>
          <h1 className="font-SFPro font-bold text-2xl md:text-4xl text-gray-900">
            Hello, {this.props.user?.first_name} {this.props.user?.last_name}
          </h1>
          <p className="font-SFPro font-medium text-base md:text-lg text-gray-400 mt-2">
            How can I assist you?
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    resetContinueChatSessionAction,
    GetUserAction,
  })(NewChat)
);
